import React, { createElement } from "react";
import { Circle, LayerGroup, LayersControl, Polyline, Tooltip } from "react-leaflet";

/**
 * Renders a toggleable trail layer on a map.
 * @param {Object} props The component properties.
 * @param {string} props.name The name of the trail.
 * @param {string} props.color The color of the trail.
 * @param {boolean} props.control Whether the layer should render as a layer control group.
 * @param {boolean} props.show Whether the trail should be shown by default.
 * @param {import("leaflet").LatLngExpression[]} props.positions The positions that make up the trail.
 * @returns {import("react").ReactNode}
 */
export default function Trail({ name, color, positions, control = true, show = false }) {
    return createElement(control ? LayersControl.Overlay : React.Fragment, control ? { checked: show, name } : null,
        positions.length > 0 && <LayerGroup>
            <Polyline weight={5} color={color} positions={[...positions, positions[0]]} />
            <Circle color={color} center={positions[0]} radius={6} fillColor={color} fillOpacity={0.5}>
                <Tooltip content="Start Here" direction="top" permanent position={positions[0]} />
            </Circle>
        </LayerGroup>
    );
}